import { render, staticRenderFns } from "./WatingList.vue?vue&type=template&id=5524b884"
import script from "./WatingList.js?vue&type=script&lang=js&external"
export * from "./WatingList.js?vue&type=script&lang=js&external"
import style0 from "./WatingList.vue?vue&type=style&index=0&id=5524b884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports